/** MI DOMINO - the rank ladder (Jerry's canon, 10 ranks) and current-rank lookup. */
import { STATS } from '../state';

export interface RankInfo {
  xp: number; idx: number; emoji: string; name: string; eng: string;
  next: [string, string, string, number] | null; pct: number;
}

export const RANKS: [string, string, string, number][] = [
  ['🌱', 'Pekeke', 'Newbie', 0],
  ['⭐', 'Rookie', 'Rookie', 100],
  ['🐚', 'El Más o Menos', 'The OK One', 250],
  ['💠', 'El Pro', 'The Pro', 500],
  ['💎', 'El Matatán', 'The Top Dog', 900],
  ['🐯', 'El Tigre', 'The Tiger', 1500],
  ['👑', 'El Rey', 'The King', 2400],
  ['🔮', 'El Monstro', 'The Monster', 3600],
  ['🏆', 'El Jefe', 'The Boss', 5200],
  ['🦍', 'King Kong', 'King Kong', 7500],
];

/** Rank colors (1 → 10) and the domino split for each rank: the two halves always add up to the rank number. */
export const RANK_COLORS: string[] = ['#8a96a8', '#c4874a', '#ff8a52', '#d6e2f0', '#4fb8ff', '#2fbf7a', '#f0b429', '#8b5cf6', '#d1244f', '#f0b429'];
export const RANK_SPLIT: [number, number][] = [[1, 0], [1, 1], [1, 2], [2, 2], [2, 3], [3, 3], [3, 4], [4, 4], [4, 5], [6, 4]];

/** Rank index for any XP total (the ladder is shared: yours, a rival's card). */
export function rankFor(xp: number): number {
  let i = 0;
  for (let k = 0; k < RANKS.length; k++) if (xp >= RANKS[k][3]) i = k;
  return i;
}

export function rankInfo(): RankInfo {
  const xp = STATS.xp || 0;
  let i = 0;
  for (let k = 0; k < RANKS.length; k++) if (xp >= RANKS[k][3]) i = k;
  const next = RANKS[i + 1] || null;
  const pct = next ? Math.min(100, Math.round((xp - RANKS[i][3]) / (next[3] - RANKS[i][3]) * 100)) : 100;
  return { xp, idx: i, emoji: RANKS[i][0], name: RANKS[i][1], eng: RANKS[i][2], next, pct };
}
